var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { Inset, InsetSize } from '@doordash/design-language';
import i18n from '../../../i18n';
import { IMAGE_BASE_URL } from '../../../constants/values';
export var HeaderContainer = styled(Inset).attrs(function () { return ({
    horizontalSize: InsetSize.Small,
    verticalSize: InsetSize.XSmall,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var LogoContainer = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: -4px; // this somehow gets magically added\n"], ["\n  margin-bottom: -4px; // this somehow gets magically added\n"])));
var logoHeight = 26;
var logos = {
    ddfbTruncated: {
        en: IMAGE_BASE_URL + "/p/fit=scale-down,height=" + logoHeight + ",format=auto/managed/consumer/teams/logo_en_ddfb_truncated.png",
        fr: IMAGE_BASE_URL + "/p/fit=scale-down,height=" + logoHeight + ",format=auto/managed/consumer/teams/logo_fr_ddfb_truncated.png",
        es: IMAGE_BASE_URL + "/p/fit=scale-down,height=" + logoHeight + ",format=auto/managed/consumer/teams/logo_es_ddfb_truncated.png",
    },
};
// "for Business" logo only header
// Note: we can extend this with types when we have more varieties in the header
export var FullScreenLayoutHeader = function () {
    var defaultLogoImgUrl = logos.ddfbTruncated.en;
    var locale = i18n.getCurrentLocale();
    var lang = (locale === null || locale === void 0 ? void 0 : locale.slice(0, 2)) || 'en';
    var logoImgUrl = logos.ddfbTruncated[lang] || defaultLogoImgUrl;
    return (React.createElement(HeaderContainer, null,
        React.createElement(LogoContainer, { src: logoImgUrl, alt: i18n.t('logo_altText') })));
};
export default FullScreenLayoutHeader;
var templateObject_1, templateObject_2;
